import { TFunction } from 'i18next'
import React, { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import DataTable from '../../components/DataTable'
import Loading from '../../layout/Loading'
import InfoService from '../../service/InfoService'
import { formatBooleanColumn } from '../../utils/DatatableUtil'
import GatewayType from '../GatewayType'

const Database: GatewayType = () => {
  const { t } = useTranslation()
  const [config, setConfig] = useState({} as any)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    InfoService.getDatabaseConfig()
      .then((config) => setConfig(config))
      .finally(() => setLoading(false))
  }, [])

  const columns = useMemo(() => {
    return [
      {
        text: 'label',
        dataField: 'label',
        classes: 'font-weight-bolder',
        sort: true,
      },
      {
        text: 'value',
        dataField: 'value',
        sort: true,
        formatter: (cell: any, row: any) => (row.label === t('useTls') ? formatBooleanColumn(cell) : cell),
      },
    ]
  }, [t])

  const data = getData(config, t)

  return (
    <Loading isLoading={loading}>
      <DataTable keyField='label' data={data} columns={columns} headerClasses='d-none' searchable={false} caption={t('database')} />
    </Loading>
  )
}

function getData(config: any, t: TFunction) {
  return Object.keys(config).length > 0
    ? [
        {
          label: t('databaseType'),
          value: config.databaseType,
        },
        {
          label: t('useTls'),
          value: config.useTls,
        },
        {
          label: t('username.text'),
          value: config.username,
        },
        {
          label: t('password.text'),
          value: config.password ? '<Protected>' : '',
        },
        {
          label: t('databaseName'),
          value: config.databaseName,
        },
        {
          label: t('databaseServer'),
          value: config.databaseServer,
        },
        {
          label: t('port.text'),
          value: config.port,
        },
      ]
    : []
}

export default Database
